import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import {
    AllowedOrgUnit,
    AllowedOrgUnits,
    Combinator,
    CompositeFilter,
    CompositePredicate,
    OrgUnitsTypes,
    SimplePredicate
} from '../filter.type';
import { PredicatesService, uniqueId, CompositePredicateComponent } from '@teammood/filter';

@Component({
    selector: 'tm-filter-editor',
    templateUrl: './filter-editor.component.html',
    styleUrls: ['./filter-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CompositePredicateComponent,
        MatMenuModule,
        TranslateModule
    ]
})
export class FilterEditorComponent {
  private _orgUnits: AllowedOrgUnits[];
  orgUnitTypes: (OrgUnitsTypes | 'tag')[];
  predicate: CompositePredicate;

  @Input()
  set filter(filter: CompositeFilter) {
    if (filter) {
      this.predicates = filter.predicates;
    }
  }

  set predicates(predicates: CompositePredicate[]) {
    const predicatesWithIds = this._predicatesService.addMissingIdToPredicate(predicates);
    this.predicate = predicatesWithIds[0];
  }

  get predicates() {
    return this.predicate ? [this.predicate] : [];
  }

  @Input()
  set orgUnits(orgUnits: AllowedOrgUnits[]) {
    this._orgUnits = orgUnits;

    if (orgUnits) {
      this.orgUnitTypes = orgUnits.map(orgUnit => {
        return orgUnit.type;
      });
    }
  }

  get orgUnits() {
    return this._orgUnits;
  }

  @Output()
  filterChange = new EventEmitter<CompositeFilter>();

  constructor(private _predicatesService: PredicatesService) {

  }

  addOrgUnitType(orgUnitType: OrgUnitsTypes | 'tag') {
    const new_predicate = this._createPredicate(orgUnitType);
    this.predicates = this._predicatesService.addOrgUnitType(new_predicate, this.predicates);
  }

  onUpdateOrgUnitValue(value: AllowedOrgUnit, id: string) {
    this.predicates = this._predicatesService.updatePredicate(this.predicates, id, value) as CompositePredicate[];
    this._emitFilterChange();
  }

  onUpdateCombinator(combinator: Combinator, id: string) {
    this.predicates = this._predicatesService.updatePredicate(this.predicates, id, combinator) as CompositePredicate[];
    this._emitFilterChange();
  }

  onRemovePredicate(id: string) {
    this.predicates = this._predicatesService.removePredicate(this.predicates, id, false) as CompositePredicate[];
    this._emitFilterChange();
  }

  onAddFilterInGroup(orgUnitType: OrgUnitsTypes | 'tag', id: string) {
    this.predicates = this._predicatesService.addFilterInGroup(this.predicates, id, this._createPredicate(orgUnitType)) as CompositePredicate[];
    this._emitFilterChange();
  }

  private _emitFilterChange() {
    this.filterChange.emit({
      predicates: this.predicates
    });
  }

  private _createPredicate(newOrgUnitType: OrgUnitsTypes | 'tag'): SimplePredicate {
    return {
      org_unit_type: newOrgUnitType,
      id: uniqueId()
    };
  }

}
